import { BourqueCoreModule } from '@bds/core';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtCityAliasDialogComponent } from './rt-city-alias-dialog/rt-city-alias-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    declarations: [RtCityAliasDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        BourqueCoreModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatAutocompleteModule,
    ],
    exports: [RtCityAliasDialogComponent],
})
export class RtCityAliasModule {}
